const types = {
    TIME_SET_LAST_MINUTES_MODE: 'TIME_SET_LAST_MINUTES_MODE',
    TIME_SET_PAUSE_TIME: 'TIME_SET_PAUSE_TIME',
    TIME_SET_PENDING_RESUME_NAVIGATION: 'TIME_SET_PENDING_RESUME_NAVIGATION',
    TIME_SET_TIME_REMAINING_FETCHED_FROM_SERVER: 'TIME_SET_TIME_REMAINING_FETCHED_FROM_SERVER',
    TIME_SET_TIME_REMAINING: 'TIME_SET_TIME_REMAINING',
};

const timeActions = {
    types,

    /**
     * @param {int} timeRemaining in ms
     * @param {int} timeRemainingSetAt Timestamp for when the timeRemaining was set.
     * @returns {{type: string, timeRemaining: int, timeRemainingSetAt: int}}
     */
    setTimeRemaining(timeRemaining, timeRemainingSetAt) {
        return { type: types.TIME_SET_TIME_REMAINING, timeRemaining, timeRemainingSetAt };
    },

    /**
     * @param {int} timeRemainingFetchedFromServer in ms
     * @param {int} timeRemainingFetchedFromServerAt Timestamp for when the timeRemainingFetchedFromServer was set.
     * @param {boolean} testDurationUsed If the test has a duration set.
     * @param {int} testDuration The duration (max time available) for the test.
     * @param {int} pauseTime Time stamp of the start of the pause.
     * @param {int} endTime Time stamp of the end time for the candidate.
     * @param {int} remainingTimePrimaryEndTime Indicates how much time is left before late submission phase starts
     * @returns {{type: string, timeRemainingFetchedFromServer: int, timeRemainingFetchedFromServerAt: int}}
     */
    setTimeRemainingFetchedFromServer(
        timeRemaining,
        timeRemainingSetAt,
        timeRemainingFetchedFromServer,
        timeRemainingFetchedFromServerAt,
        testDurationUsed,
        testDuration,
        pauseTime,
        endTime,
        remainingTimePrimaryEndTime,
    ) {
        return {
            type: types.TIME_SET_TIME_REMAINING_FETCHED_FROM_SERVER,
            timeRemaining,
            timeRemainingSetAt,
            timeRemainingFetchedFromServer,
            timeRemainingFetchedFromServerAt,
            testDurationUsed,
            testDuration,
            pauseTime,
            endTime,
            remainingTimePrimaryEndTime,
        };
    },

    setPauseTime(pauseTime) {
        return {
            type: types.TIME_SET_PAUSE_TIME,
            pauseTime,
        };
    },

    setLastMinutesMode(finalMinutesMode) {
        return { type: types.TIME_SET_LAST_MINUTES_MODE, finalMinutesMode };
    },

    setPendingResumeNavigation(pendingResumeNavigation) {
        return { type: types.TIME_SET_PENDING_RESUME_NAVIGATION, pendingResumeNavigation };
    },

    resetPendingResumeNavigation() {
        return this.setPendingResumeNavigation(null);
    },
};

export default timeActions;
